import styled from 'styled-components';

import Dialog from 'components/dialog';
import Picture from 'components/picture';

export const StyledTitle = styled.h4`
  margin: 0 auto;
  font-family: ${Styles.fontFamily.alternative};
  font-size: 2.25rem;
`;

export const StyledDescription = styled.p`
  margin: 0.5rem auto 0;
  font-family: ${Styles.fontFamily.body};
  font-size: 1rem;
`;

export const StyledDialog = styled(Dialog)`
  padding-top: 1.5rem;
  text-align: center;
  max-width: 24rem;
`;

export const StyledPicture = styled(Picture)`
  height: 12rem;
  width: 11rem;
  margin: auto;

  img {
    object-fit: contain;
  }
`;

export const StyledButtonGroup = styled.div`
  margin-top: 1.125rem;
  text-align: center;
  & button {
    width: 100%;
    margin-top: 1.125rem;
  }
`;
